<template>
<main class="bg-main lesson-exam">
  <contenthead :section="sectionData" :lesson="lessonData"></contenthead>
  <section class="container">
    <lessonquestion v-if="examData.content.questions && step" :key="$route.params.lesson_id" :questions="examData.content.questions" :step="step" @finquiz="finQuiz" @passedquiz="passedQuiz" @scoreresult="scoreResult"></lessonquestion>


    <div class="row pd-lr-20" v-if="fin_quiz">
      <button type="button" class="button button-primary next" v-show="(score_result && score_result!='failure')" @click.prevent="completedSection">{{ $t('lesson.exam.button.next') }}</button>
      <button type="button" class="button undo" :class="(score_result && score_result=='failure') ? 'button-primary' : 'button-default'" @click.prevent="restartQuiz">{{ $t('lesson.question.button.over') }}</button>
      <button type="button" class="button button-default back" @click="back">{{ $t('lesson.exam.button.to_session') }}</button>
    </div>
    <div class="space-20"></div>
  </section>

</main>
</template>

<script>
import learningLog from '../../mixins/learning-log';
import status from '../../mixins/status';
import {mapState} from 'vuex'

import componentContentHead from '../shared/ContentHead.vue';
import LessonQuestion from './LessonQuestion.vue'

export default {
  mixins: [
    learningLog,
    status
  ],
  components: {
    'contenthead': componentContentHead,
    'lessonquestion': LessonQuestion,
  },
  data(){
    return{
      step: 'exam',
      fin_quiz: false,
      passed_quiz: false,
      score_result: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth
    }),
    sectionData() {
      return this.$store.getters.section_data;
    },
    lessonData() {
      return this.$store.getters.lesson_data;
    },
    examData() {
      return this.$store.getters.lesson_content.exam ? this.$store.getters.lesson_content.exam : {content: []}
    },
  },

  created() {

      if(!this.$store.getters.section_data || Object.keys(this.$store.getters.section_data).length == 0) {
        this.$router.push({name: 'lesson.introduction'});
      }
  },
  mounted() {
  },
  methods: {
    finQuiz() {
      this.fin_quiz = true
    },
    passedQuiz() {
      this.passed_quiz = true
    },
    scoreResult(result) {
      this.score_result = result
    },
    async completedSection() {
      let self = this;
      const status_content = async function() {
        if (self.$store.getters.lesson_content[self.step].status != 'completed') {
          self.statusContent('completed', self.step);
        }
      }
      // Update status the first time and pass
      const status_lesson = async function() {
        if (self.passed_quiz && self.$store.getters.lesson_status != 'completed') {
          self.statusLesson('completed');
        }
      }
      const status_section = async function() {
        if (self.passed_quiz && self.$store.getters.section_status != "completed") {
          self.statusSection('completed');
        }
      }

      // Run synchronously
      const processAll = async function() {
        await status_content()
        await status_lesson()
        await status_section()

        self.learningTempLog();
        // Update Log
        self.learningLog();

        window.location.href = `${window.global.jsl_front_url}/method/`

      }
      await processAll()
    },

    restartQuiz(){
      this.$router.go()
    },

    back() {
      window.location.href = `/method/?section_id=${self.$store.getters.lesson_data.section_id}`
    }
  }
}
</script>

<style scoped>
</style>
